//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Carousel from './components/Carousel/Carousel'
import Notice from './components/Notice/Notice'
import HotCoins from './components/HotCoins/HotCoins'
import Poster from './components/Poster/Poster'
import Menus from './components/Menus/Menus'
import Ranking from './components/Ranking/Ranking'
import HomeHeader from './components/HomeHeader/HomeHeader'
import QuickMenus from './components/QuickMenus/QuickMenus'

import { initStateInCacheHas, checkCacheVersionIsRight, cacheObjByKey, CACHE_INFO_KEYS } from '../../utils/cache'
import { __SYSTEM_NOTICE__ } from '../../utils/stroage/nameSpace'
import { sysNoticeList } from '../../api/system/system'
import { mapState, mapGetters } from 'vuex'
import isActive from '../../mixins/isActive'

let getCoinListWithPriceTimer

export default {
  name: 'Home',
  components: { Carousel, Notice, HotCoins, Poster, Menus, Ranking, HomeHeader, QuickMenus },
  mixins: [ isActive ],
  data () {
    return {
      dialogNotices: {
        visible: false,
        finishUpdateTime: '',
        cacheInfoKey: CACHE_INFO_KEYS.SYS_NOTICE,
        onlyShowOnce: false,
        items: [],
        currentIndex: 0
      },
      noticesPop: {
        visible: false
      },
      noticeDetail: {
        visible: false,
        info: {}
      }
    }
  },
  computed: {
    ...mapState({
      locale: state => state.i18n.locale,
      vcListState: state => state.vc.vcList,
      tradeConfigState: state => state.vc.tradeConfig
    }),
    ...mapGetters([
      'cacheInfo', 'vcListNoSettleEnabled'
    ])
  },
  watch: {
    cacheInfo () {
      if (this.isActive && !checkCacheVersionIsRight({ ...this.dialogNotices, [`value_${this.locale}`]: !0 })) {
        this.initSystemNotices()
      }
      if (this.isActive && !checkCacheVersionIsRight({ ...this.vcListState })) {
        this.$store.dispatch('getVcList')
      }
      if (this.isActive && !checkCacheVersionIsRight({ ...this.tradeConfigState })) {
        this.$store.dispatch('getTradeConfig')
      }
    },
    locale () {
      if (this.isActive) {
        this.initSystemNotices()
        this.$store.dispatch('getVcList')
          .then(() => {
            this.getCoinListWithPriceInterval()
              .then(() => {
                setTimeout(() => {
                  this.$refs[`ranking`].$refs[`coins-slide`].refresh()
                }, 60)
              })
          })
        this.$store.dispatch('getTradeConfig')
      }
    }
  },
  methods: {
    initSystemNotices () {
      return new Promise((resolve, reject) => {
        const cacheNoticeInfo = initStateInCacheHas(__SYSTEM_NOTICE__) || {}
        if (checkCacheVersionIsRight(cacheNoticeInfo)) {
          this.dialogNotices.items = cacheNoticeInfo[`value_${this.locale}`].data
          this.dialogNotices.finishUpdateTime = cacheNoticeInfo[`value_${this.locale}`].finishUpdateTime
        } else {
          sysNoticeList({ languageCode: this.locale })
            .then(res => {
              if (res.success) {
                const { data: notices } = res
                if (notices) {
                  this.dialogNotices.finishUpdateTime = cacheObjByKey(__SYSTEM_NOTICE__, notices)[`value_${this.locale}`].finishUpdateTime
                  this.dialogNotices.items = notices
                }
              } else {
                this.$message.error(res.message)
                return reject(new Error(res.message))
              }
            })
            .catch(err => {
              this.$message.error(err.message)
              return reject(err)
            })
        }
      })
    },
    clickNoticeItem (index) {
      if (!this.dialogNotices.items[index]) return
      this.noticeDetail.info = this.dialogNotices.items[index]
      this.noticeDetail.visible = true
    },
    visibilityChange () {
      if (document.visibilityState === 'hidden') {
        clearTimeout(getCoinListWithPriceTimer)
      } else {
        this.getCoinListWithPriceInterval()
      }
    },
    getCoinListWithPriceInterval () {
      return new Promise((resolve, reject) => {
        clearTimeout(getCoinListWithPriceTimer)
        if (!this.isActive) {
          return
        }
        this.$store.dispatch('getCoinListWithPrice')
          .then(() => {
            getCoinListWithPriceTimer = setTimeout(() => {
              this.getCoinListWithPriceInterval()
            }, 3000)
            return resolve()
          })
          .catch(() => {
            getCoinListWithPriceTimer = setTimeout(() => {
              this.getCoinListWithPriceInterval()
            }, 3000)
            return resolve()
          })
      })
    }
  },
  activated () {
    document.addEventListener('visibilitychange', this.visibilityChange)
    this.initSystemNotices()
    this.$store.dispatch('getTradeConfig')
    // 获取系统币种列表信息
    this.$store.dispatch('getVcList')
      .then(() => {
        this.getCoinListWithPriceInterval()
      })
      .catch(err => {
        console.log(err)
      })
  },
  deactivated () {
    clearTimeout(getCoinListWithPriceTimer)
    document.removeEventListener('visibilitychange', this.visibilityChange)
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/Home.vue